$(document).ready(function($){
  // nav-item animation
  let tl1 = gsap.timeline({delay: .2});
  tl1.from(".mobile-nav > li",{
    opacity: 0,
    x: -100,
    stagger: .2
  });
  tl1.pause();  
  $(".js-mobile-nav-toggle").click(function(){
    tl1.play();
  });
  $(".closemmn").click(function(){
    tl1.reverse();
  });
  //end

  // collection list animation
  let cardWrapper = $(".anim-card__wrapper");
  cardWrapper.each((i, wrapper)=>{
    gsap.from($(wrapper).find(".anim-card"), {
      scrollTrigger:{
        trigger: wrapper,
        start: "top 80%",
        end:"top 70%",
        toggleActions: "play none none none",
        onEnter: ()=>{
          // console.log("Visible cards");
        }
      },
      opacity: 0,
      y:100,
      stagger: .2
    })
  });
  // end

  // For single product page current variant should be highlighted
  if($('.related-product')){
    let currentUrl = window.location.href;
    let relatedProductsUrl = $('.related-product');
  
    relatedProductsUrl.each((i, prod)=>{
      if(currentUrl == prod.href){
        $(prod).css("border-color", "black");
      }
    });    
  }
  // end

  // Smooth scrolling when clicking on anchor #
  $(document).on('click', 'a[href^="#"]', function(event) {
    var secID = $.trim($(this).attr('href'));
    if (secID === '#') return;
    event.preventDefault();
    if ($(secID).length) {
      $('html, body').animate({ scrollTop: $(secID).offset().top - 70 }, 500);
    }
  });
  // End

  // fontfamily adding of form heading
  //  setTimeout(() => {
  //     const $formEmbed = $('form-embed');
  //     if ($formEmbed.length && $formEmbed[0].shadowRoot) {
  //         const shadowRoot = $formEmbed[0].shadowRoot;
  //         const $heading = $(shadowRoot).find('h2');
  //         if ($heading.length) {
  //             $heading.css('font-family', 'PPGatwick-Bold, sans-serif');
  //         }
  //     }
  // }, 1000); 
  // end

  // // initialize slider for card details card only for mobile
  // if($('.cards-details__slider > .cards-details__cards').length && window.innerWidth < 766){
  //   var flkty = new Flickity('.cards-details__slider > .cards-details__cards', {
  //       cellAlign: 'left',
  //       groupCells: true,
  //       wrapAround: true,
  //       pageDots: true,
  //       prevNextButtons: false,
  //       autoPlay: false
  //     });
  // }
  // end

  if($('.logo-bar-slider').length){

    let marqueeSlider = document.querySelector('.logo-bar-slider > .grid');
    let marqueeSlide = document.querySelector('.logo-bar-slider > .grid .gitem');
    let mainTicker = new Flickity('.logo-bar-slider > .grid', {
      accessibility: true,
      resize: true,
      wrapAround: true,
      prevNextButtons: false,
      pageDots: false,
      percentPosition: true,
      setGallerySize: true,
    });
    
    // Set initial position to be 0
    mainTicker.x = 0;
    
    // Start the marquee animation
    play();
    
    // Main function that 'plays' the marquee.
    function play() {
      // Set the decrement of position x
      mainTicker.x -= .5;
    
      // Settle position into the slider
      mainTicker.settle(mainTicker.x);
    
      // Set the requestId to the local variable
      requestId = window.requestAnimationFrame(play);
    }
    
    // Main function to cancel the animation.
    function pause() {
      if(requestId) {
        // Cancel the animation
        window.cancelAnimationFrame(requestId)
    
        // Reset the requestId for the next animation.
        requestId = undefined;
      }
    }
    
    // Pause on hover/focus
    marqueeSlider.addEventListener('mouseenter', () => pause());
    
    // Unpause on mouse out / defocus
    marqueeSlider.addEventListener('mouseleave', () => play());
    
  }

  // JS for the Read More toggle content
  if ($(window).width() <= 650) {
  $('.nexgi_toggle-desc').each(function() {
    var $desc = $(this);

    // Skip if content is short enough
    if ($desc[0].scrollHeight <= $desc[0].clientHeight) return;

    $desc.after('<a href="#" class="read-more-btn">Read More</a>');

    $desc.next('.read-more-btn').on('click', function(e) {
      e.preventDefault();
      var expanded = $desc.hasClass('expanded');
      $desc.toggleClass('expanded');
      $(this).text(expanded ? 'Read More' : 'Read Less');

      if (expanded) {
        $desc[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  });
}

  
})